// extracted by mini-css-extract-plugin
module.exports = {"editorBlock":"P_emUczf8_0MQYJXnKGYh"};